import React from 'react'
import { cn } from '~shared/utils/cn'

export const IconArrowRight = ({ className }: { className?: string }) => {
  return (
    <svg
      className={cn(className)}
      width='52'
      height='52'
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.1719 33.1299L33.134 18.1677'
        stroke='white'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.1719 18.1689L33.134 18.1689L33.134 33.1311'
        stroke='white'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
